import { defineStore } from 'pinia';

export const useResourceStore = defineStore('resource', {
  state: () => ({
    locations: [],
    locationsList: [],
    drawingSets: [],
    permissionRules: [],
    teamTags: [],
    teams: [],
    processes: [],
    issues: [],
  }),
  getters: {
    getLocations: (state) => state.locations,
    getLocationsList: (state) => state.locationsList,
    getDrawingSets: (state) => state.drawingSets,
    getPermissionRules: (state) => state.permissionRules,
    getTeams: (state) => state.teams,
    getProcesses: (state) => state.processes,
    getIssues: (state) => state.issues,
  },
  actions: {
    setLocationsList(locations) {
      this.locationsList = locations;
    },
    setLocations(locations) {
      this.locations = locations;
    },
    setDrawingSets(drawingSets) {
      this.drawingSets = drawingSets;
    },
    setPermissionRules(permissionRules) {
      this.permissionRules = permissionRules;
    },
    setTeamTags(teamTags) {
      this.teamTags = teamTags;
    },
    setTeams(teams) {
      this.teams = teams;
    },
    setProcesses(processes) {
      this.processes = processes;
    },
    setIssues(issues) {
      this.issues = issues;
    },
  },
});
